export enum UTA_FORM_TA_FIELD_ENUM {
  leverage = 'leverage',
  type = 'type',
  copyType = 'copyType',
  ibCode = 'ibCode',
  profitSharing = 'profitSharing',
  recommendedMinDepositAmount = 'recommendedMinDepositAmount',
  masterAccountId = 'masterAccountId',
  lot = 'lot',
  commissionAccountId = 'commissionAccountId',
  isVisible = 'isVisible',
  initialDeposit = 'initialDeposit',
}

export enum ACCOUNT_CREATE_ACTION_TYPE_ENUM {
  CREATION_SETTING = 'creationSetting',
  SELF_TRADING_TYPES = 'selfTradingTypes',
  MASTER_TRADING_TYPES = 'masterTrading',
  INVESTOR_TRADING_TYPES = 'investorTrading',
  PROCESSING = 'processing',
}

export enum EnumUTAFormTAField {
  leverage = 'leverage',
  type = 'type',
  copyType = 'copyType',
  ibCode = 'ibCode',
  profitSharing = 'profitSharing',
  recommendedMinDepositAmount = 'recommendedMinDepositAmount',
  masterAccountId = 'masterAccountId',
  lot = 'lot',
  commissionAccountId = 'commissionAccountId',
  isVisible = 'isVisible',
  initialDeposit = 'initialDeposit',
}
